import * as actionTypes from './actionTypes'

export const toggleDarkMode = () => dispatch => {
  dispatch({ type: actionTypes.TOGGLE_DARKMODE })
}
